const ExchangeCenter = () =>
  import(
    /* webpackChunkName: "invite" */ '../../pages/inviteCode/ExchangeCenter'
  )
const InviteCodeList = () =>
  import(
    /* webpackChunkName: "invite" */ '../../pages/inviteCode/InviteCodeList'
  )
const ExchangeList = () =>
  import(/* webpackChunkName: "invite" */ '../../pages/inviteCode/ExchangeList')

export default [
  {
    path: '/exchange/center',
    meta: { title: '兑换中心' },
    component: ExchangeCenter
  },
  {
    path: '/invite/code/:id',
    meta: { title: '邀请码' },
    component: InviteCodeList
  },
  {
    path: '/invite/codeItem',
    meta: { title: '邀请码' },
    component: InviteCodeList
  },
  {
    path: '/exchange/record',
    meta: { title: '兑换记录' },
    component: ExchangeList
  }
]
